import type { TokenData } from '@ori/auth';
import { OidcAccessToken, OidcClient, OidcTokenStorage } from '@ori/auth';

import { IDENTITY_CLIENT_ID } from '../constants';

export interface TokenConfiguration {
  customerId: number;
  forceReload?: boolean;
  identityUrl?: string;
  tenant: string;
}

export const getToken = async ({
  customerId,
  tenant,
  identityUrl,
  forceReload,
}: TokenConfiguration) => {
  // try to get the token from tokenService
  if (window.ori?.tokenService) {
    if (customerId > 0) {
      try {
        const oriToken = await window.ori.tokenService.getToken();
        if (oriToken) {
          return new OidcAccessToken(oriToken.Token);
        }
      } catch (error) {
        // eslint-disable-next-line no-console -- Log error to the console
        console.log('getToken error: %o', error);
      }
    } else {
      try {
        const oriToken = await window.ori.tokenService.getPublicToken();
        if (oriToken) {
          return new OidcAccessToken(oriToken.Token);
        }
      } catch (error) {
        // eslint-disable-next-line no-console -- Log error to the console
        console.log('getPublicToken error: %o', error);
      }
    }
  }

  // try to get the token from session storage
  if (customerId > 0) {
    try {
      const authToken = sessionStorage.getItem('AuthToken');
      if (authToken) {
        const transformed = JSON.parse(authToken) as TokenData;
        const token = transformed.Token;

        return new OidcAccessToken(token);
      }
    } catch (error) {
      // eslint-disable-next-line no-console -- Log error to the console
      console.log('sessionStorage AuthToken error: %o', error);
    }
  } else {
    try {
      const publicToken = sessionStorage.getItem('PublicToken');
      if (publicToken) {
        const transformed = JSON.parse(publicToken) as TokenData;
        const token = transformed.Token;

        return new OidcAccessToken(token);
      }
    } catch (error) {
      // eslint-disable-next-line no-console -- Log error to the console
      console.log('sessionStorage PublicToken error: %o', error);
    }
  }

  // only on dev machine, not needed elsewhere
  if (process.env.NODE_ENV !== 'production') {
    const oidcTokenStorage = new OidcTokenStorage();
    let token;

    try {
      token = oidcTokenStorage.getAccessToken();
    } catch {
      throw new Error('Failed to obtain token');
    }

    if (token && !forceReload) {
      return token;
    }
    if (identityUrl) {
      const clientId = IDENTITY_CLIENT_ID;

      const oidcClient = new OidcClient(
        {
          callbackUrl: '#/',
          redirectUrl: window.location.href,
        },
        {
          clientId,
          identityUrl,

          acrValues: `tenant:${tenant}`,
          scope: 'openid profile user_identification',
        },
      );

      oidcClient.doLogin();
    }
  }

  throw new Error('Unsupported token configuration');
};
